// import React, { useEffect, useState } from "react";
// import { useLocation, useNavigate, Link } from "react-router-dom";
// import {
//   LayoutDashboard,
//   CreditCard,
//   UserPlus,
//   Package,
//   ShoppingCart,
//   Users,
//   UserCircle,
//   LogOut,
//   Menu,
//   X,
// } from "lucide-react";

// import { Outlet } from "react-router-dom";

// const sidebarItems = [
//   {
//     title: "Dashboard",
//     href: "/admin/dashboard",
//     icon: LayoutDashboard, //
//   },
//   {
//     title: "Wholesale Billing",
//     href: "/admin/billing",
//     icon: CreditCard, //
//   },
//   {
//     title: "Create ID",
//     href: "/admin/create-id",
//     icon: UserPlus, //
//   },
//   {
//     title: "Product Management",
//     href: "/admin/wholesale",
//     icon: Package, //
//   },
//   {
//     title: "Retail Billing",
//     href: "/admin/retail",
//     icon: ShoppingCart,
//   },
//   {
//     title: "Credit details",
//     href: "/admin/credit",
//     icon: ShoppingCart,
//   },

//   {
//     title: "Retail Details",
//     href: "/admin/retaildetails",
//     icon: ShoppingCart,
//   },
//   {
//     title: "Worker Bills",
//     href: "/admin/worker-bills",
//     icon: Users,
//   },

//   {
//     title: "Workers Detail",
//     href: "/admin/worker-detail",
//     icon: Users,
//   },

//   {
//     title: "Customer Details",
//     href: "/admin/customer-details",
//     icon: UserCircle, // 👤 Better icon for customer profiles
//   },
// ];
// function AdminLayout() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [sidebarOpen, setSidebarOpen] = useState(true); // Default: open

//   useEffect(() => {
//     const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//     if (currentUser.type !== "admin") {
//       navigate("/");
//     }
//   }, [navigate]);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     localStorage.removeItem("token");
//     navigate("/", { replace: true });
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 flex">
//       {/* Sidebar */}
//       <div
//         className={`fixed top-0 left-0 h-screen w-64 bg-white shadow-lg z-40 transform transition-transform duration-300 ease-in-out ${
//           sidebarOpen ? "translate-x-0" : "-translate-x-64"
//         }`}
//       >
//         <div className="flex items-center justify-between h-16 px-6 border-b">
//           <h1 className="text-xl font-bold text-green-700">
//             Murugan Ayurvedic
//           </h1>
//         </div>

//         <nav className="mt-6 px-3 overflow-y-auto h-[calc(100vh-130px)]">
//           <div className="space-y-1">
//             {sidebarItems.map((item) => {
//               const Icon = item.icon;
//               const isActive = location.pathname === item.href;

//               return (
//                 <Link
//                   key={item.href}
//                   to={item.href}
//                   className={`no-underline flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
//                     isActive
//                       ? "bg-green-100 text-green-700"
//                       : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
//                   }`}
//                   onClick={() => {
//                     if (window.innerWidth < 1024) {
//                       // Only close if screen < lg
//                       setSidebarOpen(false);
//                     }
//                   }}
//                 >
//                   <Icon className="mr-3 h-5 w-5" />
//                   {item.title}
//                 </Link>
//               );
//             })}
//           </div>
//         </nav>

//         <div className="absolute bottom-0 w-full p-3">
//           <button
//             onClick={handleLogout}
//             className="w-full flex items-center justify-start px-3 py-2 text-sm text-gray-700 hover:text-red-600 border rounded-md"
//           >
//             <LogOut className="mr-3 h-4 w-4" />
//             Logout
//           </button>
//         </div>
//       </div>

//       {/* Main Content Area */}
//       <div
//         className={`flex-1 transition-all duration-300 ease-in-out ${
//           sidebarOpen ? "ml-64" : "ml-0"
//         }`}
//       >
//         {/* Sticky Top Navbar */}
//         <div className="bg-white shadow-sm border-b sticky top-0 z-30">
//           <div className="flex items-center justify-between h-16 px-4">
//             <button onClick={() => setSidebarOpen(!sidebarOpen)}>
//               <Menu className="h-6 w-6 text-gray-800" />
//             </button>
//             <h1 className="text-lg font-semibold text-green-700">
//               Admin Panel
//             </h1>
//             <div className="w-6" /> {/* Spacer */}
//           </div>
//         </div>

//         {/* Page content */}
//         <main className="p-6 min-h-screen bg-gray-50">
//           <Outlet />
//         </main>
//       </div>
//     </div>
//   );
// }

// export default AdminLayout;

// import React, { useEffect, useState } from "react";
// import { Outlet, NavLink, useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Button,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";
// import {
//   LayoutDashboard,
//   CreditCard,
//   UserPlus,
//   Package,
//   ShoppingCart,
//   Users,
//   UserCircle,
// } from "lucide-react";
// import { LogOut, User } from "lucide-react";

// const drawerWidth = 260;

// const sidebarItems = [
//   {
//     title: "Dashboard",
//     href: "/admin/dashboard1",
//     icon: <LayoutDashboard size={20} />,
//   },
//   {
//     title: "Wholesale Billing",
//     href: "/admin/billing",
//     icon: <CreditCard size={20} />,
//   },
//   {
//     title: "Workers Bills",
//     href: "/admin/workers-bills",
//     icon: <Users size={20} />,
//   },
//   {
//     title: "Create ID",
//     href: "/admin/create-id",
//     icon: <UserPlus size={20} />,
//   },
//   {
//     title: "Product Management",
//     href: "/admin/wholesale",
//     icon: <Package size={20} />,
//   },
//   {
//     title: "Retail Billing",
//     href: "/admin/retail",
//     icon: <ShoppingCart size={20} />,
//   },
//   {
//     title: "Credit Details",
//     href: "/admin/credit",
//     icon: <CreditCard size={20} />,
//   },
//   {
//     title: "Retail Details",
//     href: "/admin/retaildetails",
//     icon: <ShoppingCart size={20} />,
//   },
//   {
//     title: "Worker Requests",
//     href: "/admin/worker-bills",
//     icon: <Users size={20} />,
//   },
//   {
//     title: "Workers Detail",
//     href: "/admin/worker-detail",
//     icon: <Users size={20} />,
//   },
//   {
//     title: "Customer Details",
//     href: "/admin/customer-details",
//     icon: <UserCircle size={20} />,
//   },
// ];

// export default function AdminLayout() {
//   const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [username, setUsername] = useState("Admin");

//   useEffect(() => {
//     const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//     if (currentUser.type !== "admin") {
//       navigate("/");
//     } else {
//       setUsername(currentUser.username || "Admin");
//     }
//   }, [navigate]);

//   const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     localStorage.removeItem("token");
//     navigate("/", { replace: true });
//   };

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0F3E2C",
//         color: "#FFFFFF",
//         overflow: "hidden", // Prevents unnecessary scrollbars
//       }}
//     >
//       {/* Sidebar header */}
//       <Toolbar sx={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
//         <Typography
//           variant="h6"
//           noWrap
//           sx={{ fontWeight: "bold", color: "#FFD700" }}
//         >
//           Murugan Ayurvedic
//         </Typography>
//       </Toolbar>

//       {/* Sidebar nav */}
//       <Box
//         sx={{
//           flex: 1,
//           overflowY: "auto",
//           p: 1,
//           "&::-webkit-scrollbar": {
//             width: "8px",
//           },
//           "&::-webkit-scrollbar-track": {
//             background: "transparent",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             backgroundColor: "rgba(255,255,255,0.3)",
//             borderRadius: "4px",
//             visibility: "hidden", // Hide scrollbar by default
//           },
//           "&:hover::-webkit-scrollbar-thumb": {
//             visibility: "visible", // Show when hovering/scrolling
//           },
//           scrollbarWidth: "thin", // Firefox
//           scrollbarColor: "rgba(255,255,255,0.3) transparent", // Firefox
//         }}
//       >
//         <List>
//           {sidebarItems.map((item) => (
//             <ListItem key={item.href} disablePadding>
//               <ListItemButton
//                 component={NavLink}
//                 to={item.href}
//                 onClick={() => setMobileOpen(false)}
//                 sx={{
//                   borderRadius: 1,
//                   mb: 0.5,
//                   py: 1.2,
//                   px: 2,
//                   fontSize: "0.95rem",
//                   color: "rgba(255,255,255,0.85)",
//                   textDecoration: "none",
//                   transition: "background-color 0.3s ease",
//                   "&.active": {
//                     bgcolor: "#2C5F49",
//                     color: "#fff",
//                     fontWeight: "bold",
//                     "& .MuiListItemIcon-root": { color: "#fff" },
//                   },
//                   "&:hover": {
//                     bgcolor: "#1B4D38",
//                     color: "#fff",
//                   },
//                 }}
//               >
//                 <ListItemIcon
//                   sx={{
//                     color: "inherit",
//                     minWidth: 36,
//                   }}
//                 >
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.title}
//                   primaryTypographyProps={{ fontSize: "0.95rem" }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />

//       {/* Top AppBar */}
//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: "white",
//           color: "black",
//           boxShadow: 1,
//         }}
//       >
//         <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//           {/* Mobile menu button */}
//           <IconButton
//             color="inherit"
//             edge="start"
//             onClick={handleDrawerToggle}
//             sx={{ mr: 2, display: { sm: "none" } }}
//           >
//             <MenuIcon />
//           </IconButton>

//           {/* Right side */}
//           <Box
//             sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}
//           >
//             <Typography variant="body1" sx={{ fontWeight: 500 }}>
//               {/* {username}
//                */}
//               <div className="flex items-center space-x-2 px-3 py-2 bg-muted/50 rounded-lg">
//                 <User className="h-4 w-4 text-muted-foreground" />
//                 <span className="text-sm font-medium text-foreground">
//                   {username}
//                 </span>
//               </div>
//             </Typography>
//             <Button
//               onClick={handleLogout}
//               variant="contained"
//               color="error"
//               size="small"
//               startIcon={<LogoutIcon />}
//               sx={{ textTransform: "none", borderRadius: 2 }}
//             >
//               Logout
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar */}
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//         aria-label="sidebar"
//       >
//         {/* Mobile Drawer */}
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               bgcolor: "#1e1e2f",
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         {/* Desktop Drawer */}
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               bgcolor: "#1e1e2f",
//               color: "white",
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 1, sm: 3 },
//           width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
//           mt: 8,
//           bgcolor: "#f5f5f5",
//           minHeight: "100vh",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

// // bg-gradient-to-br from-[#F9FAFB] to-[#F3F4F6]

// import React, { useEffect, useState } from "react";
// import { Outlet, NavLink, useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Button,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";
// import {
//   LayoutDashboard,
//   CreditCard,
//   UserPlus,
//   Package,
//   ShoppingCart,
//   Users,
//   UserCircle,
//   User,
// } from "lucide-react";

// const drawerWidth = 260;

// const sidebarItems = [
//   {
//     title: "Dashboard",
//     href: "/admin/dashboard1",
//     icon: <LayoutDashboard size={18} />,
//   },
//   {
//     title: "Wholesale Billing",
//     href: "/admin/billing",
//     icon: <CreditCard size={18} />,
//   },
//   {
//     title: "Workers Bills",
//     href: "/admin/workers-bills",
//     icon: <Users size={18} />,
//   },
//   {
//     title: "Create ID",
//     href: "/admin/create-id",
//     icon: <UserPlus size={18} />,
//   },
//   {
//     title: "Product Management",
//     href: "/admin/wholesale",
//     icon: <Package size={18} />,
//   },
//   {
//     title: "Retail Billing",
//     href: "/admin/retail",
//     icon: <ShoppingCart size={18} />,
//   },
//   {
//     title: "Credit Details",
//     href: "/admin/credit",
//     icon: <CreditCard size={18} />,
//   },
//   {
//     title: "Retail Details",
//     href: "/admin/retaildetails",
//     icon: <ShoppingCart size={18} />,
//   },
//   {
//     title: "Worker Requests",
//     href: "/admin/worker-bills",
//     icon: <Users size={18} />,
//   },
//   {
//     title: "Workers Detail",
//     href: "/admin/worker-detail",
//     icon: <Users size={18} />,
//   },
//   {
//     title: "Customer Details",
//     href: "/admin/customer-details",
//     icon: <UserCircle size={18} />,
//   },
// ];

// export default function AdminLayout() {
//   const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [username, setUsername] = useState("Admin");

//   useEffect(() => {
//     const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
//     if (currentUser.type !== "admin") {
//       navigate("/");
//     } else {
//       setUsername(currentUser.username || "Admin");
//     }
//   }, [navigate]);

//   const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

//   const handleLogout = () => {
//     localStorage.removeItem("currentUser");
//     localStorage.removeItem("token");
//     navigate("/", { replace: true });
//   };

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0F3E2C",
//         color: "#FFFFFF",
//         overflow: "hidden", // ✅ scrollbar completely removed
//       }}
//     >
//       {/* Sidebar header */}
//       <Toolbar sx={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
//         <Typography
//           variant="h6"
//           noWrap
//           sx={{ fontWeight: "bold", color: "#FFD700" }}
//         >
//           Murugan Ayurvedic
//         </Typography>
//       </Toolbar>

//       {/* Sidebar nav */}
//       <Box sx={{ flex: 1, p: 1 }}>
//         <List>
//           {sidebarItems.map((item) => (
//             <ListItem key={item.href} disablePadding>
//               <ListItemButton
//                 component={NavLink}
//                 to={item.href}
//                 onClick={() => setMobileOpen(false)}
//                 disableRipple // ✅ remove ripple effect
//                 sx={{
//                   borderRadius: 1,
//                   mb: 0.3,
//                   py: 0.9,
//                   px: 1.5,
//                   fontSize: "1rem", // ✅ slightly bigger font
//                   fontWeight: 500, // ✅ more professional look
//                   color: "rgba(255,255,255,0.85)",
//                   textDecoration: "none",
//                   transition: "background-color 0.3s ease",
//                   "&.active": {
//                     bgcolor: "#2C5F49",
//                     color: "#fff",
//                     fontWeight: 600,
//                     "& .MuiListItemIcon-root": { color: "#fff" },
//                   },
//                   "&:hover": {
//                     bgcolor: "#1B4D38",
//                     color: "#fff",
//                   },
//                 }}
//               >
//                 <ListItemIcon sx={{ color: "inherit", minWidth: 32 }}>
//                   {item.icon}
//                 </ListItemIcon>
//                 <ListItemText
//                   primary={item.title}
//                   primaryTypographyProps={{ fontSize: "1rem", fontWeight: 500 }}
//                 />
//               </ListItemButton>
//             </ListItem>
//           ))}
//         </List>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex" }}>
//       <CssBaseline />

//       {/* Top AppBar */}
//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: "rgba(15, 62, 42, 1)", // ✅ professional dark green topbar
//           color: "white",
//           boxShadow: 1,
//         }}
//       >
//         <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//           {/* Mobile menu button */}
//           <IconButton
//             color="inherit"
//             edge="start"
//             onClick={handleDrawerToggle}
//             sx={{ mr: 2, display: { sm: "none" } }}
//           >
//             <MenuIcon />
//           </IconButton>

//           {/* Right side */}
//           <Box
//             sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 1,
//                 px: 2,
//                 py: 0.5,
//                 bgcolor: "rgba(255,255,255,0.1)",
//                 borderRadius: 2,
//               }}
//             >
//               <User size={16} />
//               <Typography variant="body2" sx={{ fontWeight: 500 }}>
//                 {username}
//               </Typography>
//             </Box>
//             <Button
//               onClick={handleLogout}
//               variant="contained"
//               size="small"
//               startIcon={<LogoutIcon />}
//               sx={{
//                 textTransform: "none",
//                 borderRadius: 2,
//                 bgcolor: "#E63946",
//                 "&:hover": { bgcolor: "#c72c38" },
//               }}
//             >
//               Logout
//             </Button>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar */}
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         {/* Mobile Drawer */}
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               bgcolor: "#0F3E2C",
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         {/* Desktop Drawer */}
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               bgcolor: "#0F3E2C",
//               color: "white",
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 1, sm: 3 },
//           width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
//           mt: 8,
//           bgcolor: "#FAFAF5",
//           minHeight: "100vh",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";

import {
  LayoutDashboard,
  CreditCard,
  UserPlus,
  Package,
  ShoppingCart,
  Users,
  UserCircle,
  FileText,
  FileStack,
  Receipt,
  Undo2,
  Boxes,
  Wallet,
  ReceiptText,
  Layers,
  UserCog,
  User,
} from "lucide-react";

// ✅ Inter font
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";

const drawerWidth = 260;

const sidebarItems = [
  {
    title: "Dashboard",
    href: "/admin/dashboard1",
    icon: <LayoutDashboard size={18} />,
  },
  {
    title: "Wholesale Billing",
    href: "/admin/billing",
    icon: <CreditCard size={18} />,
  },
  {
    title: "Workers Bills",
    href: "/admin/workers-bills",
    icon: <FileText size={18} />, // 📝 bill/invoice
  },
  {
    title: "All Workers Bills",
    href: "/admin/all-workers-bills",
    icon: <FileStack size={18} />, // 📚 multiple bills
  },
  {
    title: "Workers Credit Details",
    href: "/admin/workers-credit-details",
    icon: <Receipt size={18} />, // 💳 credit details
  },
  {
    title: "Workers Stock Return",
    href: "/admin/workerstockreturn",
    icon: <Undo2 size={18} />, // 🔄 return
  },
  {
    title: "Create Worker",
    href: "/admin/create-id",
    icon: <UserPlus size={18} />,
  },
  {
    title: "Product Management",
    href: "/admin/wholesale",
    icon: <Package size={18} />,
  },
  {
    title: "Product Details",
    href: "/admin/product-details",
    icon: <Boxes size={18} />, // 📦 details of stock
  },
  {
    title: "Retail Billing",
    href: "/admin/retail",
    icon: <ShoppingCart size={18} />,
  },
  {
    title: "Retail Credit Details",
    href: "/admin/credit",
    icon: <Wallet size={18} />, // 👛 credit/finance
  },
  {
    title: "Retail Customer Bills",
    href: "/admin/retaildetails",
    icon: <ReceiptText size={18} />, // 🧾 bills
  },
  {
    title: "Workers Detail",
    href: "/admin/worker-detail",
    icon: <Users size={18} />,
  },
  {
    title: "Customer Details",
    href: "/admin/customer-details",
    icon: <UserCircle size={18} />,
  },
  {
    title: "Stock Credit",
    href: "/admin/stock-credit",
    icon: <Layers size={18} />, // 📊 stock credit
  },
  {
    title: "Create Company Worker",
    href: "/admin/createcompanyworker",
    icon: <UserCog size={18} />, // 👷 manage worker
  },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [username, setUsername] = useState("Admin");

  // useEffect(() => {
  //   const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  //   if (currentUser.type !== "admin") {
  //     navigate("/");
  //   } else {
  //     setUsername(currentUser.username || "Admin");
  //   }
  // }, [navigate]);

  const location = useLocation();

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    // security: if not admin, redirect
    if (currentUser.type !== "admin") {
      navigate("/");
      return;
    }

    // If navigation provided a selectedWorker in state, show that.
    // Otherwise show the admin's username.
    if (location?.state && location.state.selectedWorker) {
      setUsername(location.state.selectedWorker);
    } else {
      setUsername(currentUser.username || "Admin");
    }
  }, [location, navigate]);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const handleLogout = () => {
    localStorage.removeItem("currentUser");
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  };

  const drawer = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#0F3E2C",
        color: "#FFFFFF",
        fontFamily: "Inter, sans-serif",
      }}
    >
      {/* Sidebar header */}
      <Toolbar sx={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
        <Typography
          variant="h6"
          noWrap
          sx={{
            fontWeight: 600,
            color: "#FFD700",
            fontFamily: "Inter, sans-serif",
          }}
        >
          Sri Murugan Ayurvedha
        </Typography>
      </Toolbar>

      {/* Sidebar nav with scrollable list */}
      <Box
        sx={{
          flex: 1,
          p: 1,
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: 0 }, // hide scrollbar for Chrome, Safari
          scrollbarWidth: "none", // hide scrollbar for Firefox
          "-ms-overflow-style": "none", // hide scrollbar for IE 10+
        }}
      >
        <List sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          {sidebarItems.map((item) => (
            <ListItem key={item.href} disablePadding>
              <ListItemButton
                component={NavLink}
                to={item.href}
                onClick={() => setMobileOpen(false)}
                disableRipple
                sx={{
                  borderRadius: 1.2,
                  py: 1,
                  px: 1.6,
                  fontFamily: "Inter, sans-serif",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  lineHeight: 1.5,
                  color: "rgba(255,255,255,0.85)",
                  transition: "all 0.25s ease",
                  "&.active": {
                    bgcolor: "#2C5F49",
                    color: "#fff",
                    fontWeight: 600,
                    "& .MuiListItemIcon-root": { color: "#fff" },
                  },
                  "&:hover": {
                    bgcolor: "#1B4D38",
                    color: "#fff",
                  },
                }}
              >
                <ListItemIcon sx={{ color: "inherit", minWidth: 34 }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.title}
                  primaryTypographyProps={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "0.95rem",
                    fontWeight: 500,
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", fontFamily: "Inter, sans-serif" }}>
      <CssBaseline />

      {/* Top AppBar */}
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          bgcolor: "rgba(15, 62, 42, 1)",
          color: "white",
          fontFamily: "Inter, sans-serif",
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Mobile menu button */}
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>

          {/* Right side */}
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 2, ml: "auto" }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                px: 2,
                py: 0.5,
                bgcolor: "rgba(255,255,255,0.1)",
                borderRadius: 2,
                fontFamily: "Inter, sans-serif",
              }}
            >
              <User size={16} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {username}
              </Typography>
            </Box>
            <Button
              onClick={handleLogout}
              variant="contained"
              size="small"
              startIcon={<LogoutIcon />}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                fontFamily: "Inter, sans-serif",
                fontWeight: 500,
                bgcolor: "#E63946",
                "&:hover": { bgcolor: "#c72c38" },
              }}
            >
              Logout
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Sidebar */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        {/* Mobile Drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": { width: drawerWidth, bgcolor: "#0F3E2C" },
          }}
        >
          {drawer}
        </Drawer>

        {/* Desktop Drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              bgcolor: "#0F3E2C",
              color: "white",
              overflow: "hidden", // ✅ no scrollbar
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {/* Main Content */}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 3 },
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
          mt: { xs: 7, sm: 8 }, // keep spacing for AppBar
          bgcolor: "#FAFAF5",
          height: "calc(100vh - 64px)", // AppBar height (64px default)
          overflowY: "auto", // 👈 only this scrolls
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
